import translator from '@Components/Utilities/Translator';
import ConsignmentRequestConfirmationModal from '@Components/Shared/Modals/ConsignmentRequestConfirmationModal';
import { useState } from 'react';
import ConsignmentRequestItem from '@Components/Quotes/ConsignmentRequestItem';

const MyConsignmentRequestsView = (props) => {
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null); // New state for selected request

    const toggleConfirmationModal = () => {
        setShowConfirmation(showConfirmation => !showConfirmation);
    }

    const closeModalTimer = () => {
        setShowConfirmation(false);
        setSelectedRequest(null); // Reset the selected request when modal closes
    };

    // Modified to accept the request model
    const handleDeletion = (e, request) => {
        e.preventDefault();
        setSelectedRequest(request); // Save the request model
        toggleConfirmationModal();
    };

    return (
        <div className='my-consignment-requests-container'>
            <h3>{props.DisplayedHeader}</h3>
            {props.ConsignmentRequests && props.ConsignmentRequests.length > 0 ? (
                props.ConsignmentRequests.map((request) => (
                    <ConsignmentRequestItem
                        key={request.Request?.EquipmentMessageID}
                        request={request}
                        handleDeletion={handleDeletion}
                    />
                ))
            ) : (
                    <p className="error-message">
                        {translator.translate('sandhills.noquoterequests')}
                    </p>
            )}
            {showConfirmation &&
                <ConsignmentRequestConfirmationModal
                    onClose={closeModalTimer}
                    toggleConfirmationModal={toggleConfirmationModal}
                    consignmentRequestModel={selectedRequest} // Pass the selected request as a prop
                />
            }
        </div>
    );
}

export default MyConsignmentRequestsView;
global.MyConsignmentRequestsView = MyConsignmentRequestsView;